<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					Meu perfil
				</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
            <section class="modal-card-body">

                <div class="perfil-field">

                    <div class="left">
                        <label for="meu-perfil-user-avatar">
                            <figure>
                                <img v-if="userAvatar" :src="userAvatar">

                                <svg v-if="!userAvatar" class="svgNoAvatar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
                                <circle cx="12" cy="8" r="5"/>
                                <path d="M16.5,12c-1.1,1.3-2.7,2-4.5,2s-3.4-0.8-4.5-2C5.4,13.2,4,15.4,4,18v2.9c2.1,1.9,4.9,3.1,8,3.1s5.9-1.2,8-3.1V18
                                C20,15.4,18.6,13.2,16.5,12z"/>
                                </svg>
                            </figure>
                        </label>
                   </div>
                    <div class="right">
                        <label class="button"><input id="meu-perfil-user-avatar" type="file" @change="onFileChange">Alterar foto de perfil</label>
                    </div>
                </div>
                <div class="perfil-field">

                    <div class="left"><span class="hand" @click="edit('name',user.name)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" /></svg></span></div>

                    <div class="right">
                        <strong>Nome:</strong>
                        <span v-if="field=='name'">
                            <input type="text" v-model="value">
                            <span class="button is-success btn-sm" @click="save(field,value)">OK</span>
                            <span class="button is-danger btn-sm" @click="cancelEdit">Cancelar</span>
                        </span>
                        <span v-else>{{ user.name }}</span>
                    </div>
                </div>
 
                
                <div class="perfil-field">

                    <div class="left"><span v-if="user.providerId=='password'" class="hand" @click="edit('email',user.email)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" /></svg></span></div>
                    <div class="right">
                        <strong>E-mail:</strong>
                        <span v-if="field=='email'">
                            <input type="email" v-model="value">
                            <span class="button is-success btn-sm" @click="saveEmail">OK</span>
                            <span class="button is-danger btn-sm" @click="cancelEdit">Cancel</span>
                        </span>
                        <span v-else>{{ user.email }}</span>
                    </div>
                </div>
                <div v-if="user.providerId=='password'" class="perfil-field">

                    <div class="left"><span class="hand" @click="edit('password','')"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" /></svg></span></div>
                    <div class="right">
                        <strong>Senha:</strong>
                        <span v-if="field=='password'">
                            <input type="password" v-model="value">
                            <span class="button is-success btn-sm" @click="savePassword">OK</span>
                            <span class="button is-danger btn-sm" @click="cancelEdit">Cancel</span>
                        </span>
                        <span v-else>xxxxxxxxxxxxx</span>
                    </div>
                </div>

                <div class="perfil-field">

                    <div class="left"></div>
                    <div class="right">
                        <strong>Tipo de conta:</strong>
                        <span>Básico</span>
                    </div>
                </div>

            </section>
		</div>
	</div>
</template>


<style scoped>
img { 
    max-width: 384px;
    margin: 0 auto;
}
.modal-card-title { flex-shrink: 1; }

.perfil-field { display: flex; align-items:center; padding:10px; line-height:36px; }
.perfil-field + .perfil-field { border-top:1px solid #ddd; }

.perfil-field .left { flex-basis:60px;  text-align:center; flex-shrink: 0; margin-right: 10px; }
.perfil-field .left span { display:flex; justify-content: center; }
.perfil-field .left svg { display: block; width:20px; height:20px; }
.perfil-field .left svg path {fill:#00b3bc}

.perfil-field .right strong { display:inline-block; width:110px; font-weight:normal; margin-right: 10px; }
.perfil-field .right { flex-grow: 1;}
.perfil-field .right input { font:inherit; line-height:1; height:36px; }


.perfil-field .button { margin-left:3px }


.modal-card-body .anonymousWarning { width:100%; }
.modal-card-body .anonymousWarning a { color: #009393}

.modal-card-body {  }
.modal-card-body svg.svgNoAvatar { width:100%; height:100%; display: block;}
.modal-card-body figure{ position:relative; width:60px; height:60px; border:2px solid #47cdd1; border-radius: 40px; margin: 0 auto 20px; }
.modal-card-body figure img {width:100%; height:100%; display: block; object-fit: cover; border-radius: 80px;}
.modal-card-body figure > svg path { fill:#47cdd1; }
.modal-card-body figure > svg circle { fill:#47cdd1; }
.modal-card-body input[type=file] { display: none;}

body.is-mobile .perfil-field { line-height: 1.4; }
body.is-mobile .perfil-field .right strong  {display: block; }
body.is-mobile .perfil-field .right input {margin-bottom:3px; width:100%; }



</style>

<script>

import firebase from '@/firebase';

export default {
	data() {
		return {
            user:{},
            authUser:{},
            field:'',
            value:'',

		}
    },
    computed:{
      userAvatar(){
        return this.$store.getters.preferenceAvatar;
      },

    },
	methods:{
        save(field,value){
            var obj = {}
            obj[field] = value;
            this.$store.dispatch('updateUserProfile',obj)
            this.field= '' ;

        },
        getAuthUser(){
            var user = this.$store.getters.user;
            var currentUser = firebase.auth().currentUser;
            this.authUser = currentUser;
            var providerData = currentUser.providerData[0]; 

            if(!user.name && providerData.displayName){
                user.name = providerData.displayName;
            }
            if(!user.name && user.firstName){
                user.name = (user.firstName+' '+user.lastName).trim();
                this.$store.dispatch('updateUserProfile',{name:user.name});
            }
            if(!user.email && providerData.email){
                user.email = providerData.email;
            }
            if(!user.providerId && providerData.providerId){
                user.providerId = providerData.providerId;
            }
            this.user = user;

            
        },
        saveEmail(){
            firebase.auth().currentUser.updateEmail(this.value).then((res)=>{
                this.$store.dispatch('updateUserProfile',{email:this.value})
//                this.getAuthUser();
                this.user.email = this.value
                this.field = '';
                this.value = '';
            }).catch((err)=>{
                if(err.message == 'The email address is already in use by another account.'){
                    alert('Este e-mail já está sendo usado por outro usuário.');
                    return;
                }
                if(err.message == "The email is already in use as another user's initial email."){
                alert('Este e-mail já está sendo usado por outro usuário.');
                return;
                }


                if(err.message == 'This operation is sensitive and requires recent authentication. Log in again before retrying this request.'){
                    alert('Para executar essa operação por favor faça seu login e tente novamente.');
                    return;
                }
                alert(err.message);
            });
            
        },  

        savePassword(){
            if(this.value.length<6){
                alert('Sua senha deve conter ao menos 6 caracteres.');
                return;
            }
            firebase.auth().currentUser.updatePassword(this.value).catch((err)=>{
                
                if(err.message == 'This operation is sensitive and requires recent authentication. Log in again before retrying this request.'){
                    alert('Para executar essa operação por favor faça seu login e tente novamente.');
                    return;
                }
                alert(err.message);
            });
            this.field = '';
            this.value = '';
        },  
        cancelEdit(){
            this.field= '' ;
        },
		goBack(){
			this.$router.push({name:'home'});
        },
        edit(field,currentVal){
            this.field = field;
            this.value = currentVal;
        },
        
        onFileChange(e){
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            var file = files[0];
            var reader = new FileReader();
            var img = new Image();
            reader.onload = (re) => {

            img.onload = (ie) => {

                var MAX_WIDTH = 800;
                var MAX_HEIGHT = 800;
                var width = img.width;
                var height = img.height;

                if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
                } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
                }

                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext("2d");

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                var dataurl = canvas.toDataURL("image/jpeg",0.8);

                this.$store.dispatch('setAvatar',{image:dataurl});

            }
            img.src = re.target.result;
            }
            reader.readAsDataURL(file);
        },

	},
	created() {
        this.getAuthUser();

        /*
        {
            providerId
            displayName
            email
            photoURL
        }
        */
        


	},
};
</script>

